import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../auth/services/auth.service';

@Component({
  selector: 'app-nav-bar-report',
  templateUrl: './nav-bar-report.component.html',
  styleUrls: ['./nav-bar-report.component.sass']
})
export class NavBarReportComponent implements OnInit {

  isAdmin: any = false;
  constructor(private readonly _authService: AuthService) { }

  ngOnInit() {
    this.isAdmin = (localStorage.getItem('BOOKYNGSYSTEM::admin') == 'true');
  }

  logout() {
    this._authService.logout()
  }

}
